(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benu__delivery-options"]) return;
  try {
    
const btnContinue = document.querySelector("button#checkout");
document.addEventListener("after.init.checkout.event.shopify.deliverygateway.io", () => {
	// enable continue button once a delivery option has been selected
	if(btnContinue){
		btnContinue.disabled = false;
	}
});

  } catch(e) { console.error(e); }
})();
})();
